module.exports = __webpack_public_path__ + "img/border-center.0a2deb4e.svg";